import { Button, Stack, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { GridToolbarContainer, useGridApiContext } from "@mui/x-data-grid-pro";
import { format } from "date-fns";
import { jsonToCSV } from "react-papaparse";
import fileDownload from "js-file-download";
import { useExcelExport } from "@/hooks/useExcelExport";
import { DataGridTopScrollbar } from "@/components/DataGrid/DataGridTopScrollbar";

interface Props {
  selectedCount?: number;
  pageRowCount?: number;
}
export const PropertyExportToolbar: React.FC<Props> = ({
  selectedCount = 0,
  pageRowCount = 0,
}) => {
  const apiRef = useGridApiContext();
  const { getFeedGridData } = useExcelExport();
  return (
    <GridToolbarContainer sx={{ position: "relative", padding: "16px" }}>
      <PropertyExportButtons
        selectedCount={selectedCount}
        pageRowCount={pageRowCount}
        getRows={() => getFeedGridData(apiRef, { allColumns: true })}
      />
      <DataGridTopScrollbar />
    </GridToolbarContainer>
  );
};

export const PropertyExportButtons: React.FC<
  Props & { getRows: () => string[][] }
> = ({ selectedCount = 0, pageRowCount = 0, getRows }) => {
  const { makeExcelUint8Array, downloadAsExcelFile } = useExcelExport();
  const fileName = format(new Date(), "yyyyMMdd_取得済不動産登記一覧");
  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      flexWrap="wrap"
      useFlexGap
    >
      <Button
        variant="outlined"
        disabled={!pageRowCount || !selectedCount}
        endIcon={<DownloadIcon />}
        onClick={() => {
          const rows = getRows();
          downloadAsExcelFile(
            makeExcelUint8Array(rows, "取得済不動産登記"),
            fileName
          );
        }}
      >
        EXCEL出力
      </Button>
      <Button
        variant="outlined"
        disabled={!pageRowCount || !selectedCount}
        endIcon={<DownloadIcon />}
        onClick={() => {
          const rows = getRows();
          const csv = jsonToCSV(rows, {
            escapeFormulae: /^[=+\-@\t\r\n]/,
          });
          fileDownload(csv, `${fileName}.csv`, "text/csv", "\uFEFF");
        }}
      >
        CSV出力
      </Button>
      <Typography variant="caption" color="text.secondary">
        {selectedCount
          ? `選択した ${selectedCount} 件を出力`
          : "出力する物件を選択してください"}
      </Typography>
    </Stack>
  );
};
